module.exports = __webpack_public_path__ + "static/media/GWM.0996c823.png";